import {  EstensaColDef } from '../search-param.model';
import { BoolIconRendererIconType } from '../search-result/cell-renderers/bool-icon-renderer/bool-icon-renderer.component';

export function telemonitoringColumnDefs(translate, gridUtils): EstensaColDef[] {
    return [
        {
            colId: 'lockColId',
            headerName: '',
            tooltipField: '',
            width: 50,
            suppressSizeToFit: true,
            resizable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0' },
            cellRenderer: 'lockUnlockRenderer',
            cellRendererParams: {
                lockedField: 'locked',
                userField: 'lockedUserFullName',
            },
        },
        {
            colId: 'ExamOutOfFlow',
            headerName: '',
            tooltipField: '',
            field: 'patient.isLocalPatient',
            width: 50,
            suppressSizeToFit: true,
            resizable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0' },
            cellRenderer: 'boolIconRenderer',
            cellRendererParams: {
                estensa: {
                    iconType: BoolIconRendererIconType.SeFont,
                    icon: 'icon_flusso_inverso',
                    tooltip: 'PatientDataNotAssociated',
                },
            },
        },
        {
            colId: '0',
            headerName: translate.instant('Patient'),
            headerTooltip: translate.instant('Patient'),
            valueGetter: (e) =>
                `${e.data.patient.lastName.toLocaleUpperCase()} ${e.data.patient.firstName.toLocaleUpperCase()}`,
            tooltipValueGetter: (e) =>
                `${e.data.patient.lastName.toLocaleUpperCase()} ${e.data.patient.firstName.toLocaleUpperCase()}`,
            width: 220,
            minWidth: 190,
            suppressSizeToFit: true,
            lockPosition: true,
            pinned: 'left',
            cellStyle: (e) => {
                if (e.data.patient.isCertificating === true) return { 'background-color': 'yellow' };
                if (e.data.patient.isCertificating === false && e.data.patient.isCertified === false)
                    return { 'background-color': 'red' };
                return null;
            },
        },
        {
            colId: '1',
            headerName: translate.instant('TelemonitoringType'),
            headerTooltip: translate.instant('TelemonitoringType'),
            tooltipField: 'exam.description',
            field: 'exam.description',
            width: 150,
            minWidth: 120,
            sort: 'desc',
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '2',
            headerName: translate.instant('EnrolmentStartDate'),
            headerTooltip: translate.instant('EnrolmentStartDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'examinationDate',
            width: 150,
            minWidth: 120,
            sort: 'desc',
            valueFormatter: gridUtils.dateTimeFormatter('examinationDate'),
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '3',
            headerName: translate.instant('EnrolmentEndDate'),
            headerTooltip: translate.instant('EnrolmentEndDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'approvalDate',
            width: 150,
            minWidth: 120,
            valueFormatter: gridUtils.dateTimeFormatter('approvalDate'),
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '4',
            headerName: translate.instant('TaxCode'),
            headerTooltip: translate.instant('TaxCode'),
            tooltipField: 'patient.taxCode',
            field: 'patient.taxCode',
            width: 220,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '5',
            headerName: translate.instant('Phone'),
            headerTooltip: translate.instant('Phone'),
            tooltipField: 'patient.phone',
            field: 'patient.phone',
            width: 190,
            minWidth: 160,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '6',
            headerName: translate.instant('Email'),
            headerTooltip: translate.instant('Email'),
            tooltipField: 'patient.email',
            field: 'patient.email',
            width: 220,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '7',
            headerName: translate.instant('Notes'),
            headerTooltip: translate.instant('Notes'),
            tooltipField: 'monitoringStatus',
            field: 'monitoringStatus',
            width: 120,
            minWidth: 100,
            suppressSizeToFit: false,
            hide: false,
        },
    ];
}
